import { useRouter } from 'vue-router'
import { NAV_EVENTS } from '@/components/side-nav/constants'
import marketingEventService from '@/services/marketing-event-service'
import { setMobileMenuOpen } from '@/services/control-layout-service'
import { Vertical } from '@/types/verticals'

/**
 * *(AI-generated)*
 * Composable providing side-navigation link handlers and marketing event tracking.
 */
export const useSideNavFunctions = () => {
  const router = useRouter()

  const toggle = (routePath: string) => {
    const currentRoute = router.currentRoute.value
    const matchingPaths = [currentRoute.path, currentRoute.redirectedFrom?.path]
    // Next route is considered the same if the current route matches,
    // or where the current route was redirectedFrom matches
    const isNextRouteSame = matchingPaths.includes(routePath)
    const nextRoute = isNextRouteSame ? `/fish/map` : routePath
    router.push(nextRoute).catch(() => {})
  }

  const publishMarketingEventForRoute = (routePath: string) => {
    const routeName = router.resolve(routePath).name
    if (routeName) {
      const event = NAV_EVENTS[Vertical.Fish][routeName as string]
      if (event) {
        marketingEventService.publish(event)
      }
    }
  }

  const handleLinkClick = (event: Event) => {
    const target = event.currentTarget as HTMLAnchorElement
    const url = new URL(target.href)
    toggle(url.pathname)
    publishMarketingEventForRoute(url.pathname)
    setMobileMenuOpen(false)
  }

  return { handleLinkClick }
}
